import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { consumerApplication } from './consumer-application/index';
import { financialInstitution } from './financial-institution/index';
import { productInformation } from './product-information/index';

import { bbvaDocument } from './bbva-document/index';
Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
      financialInstitution,
      consumerApplication,
      productInformation,
      bbvaDocument
  }
};

export default new Vuex.Store<RootState>(store);

